export function formatCurrency(amount = 0) {
  const options = { style: 'currency', currency: 'USD' };
  const formatter = new Intl.NumberFormat('en-US', options);

  return formatter.format(amount);
}

export function unbox(value) {
  if (Array.isArray(value)) {
    return value[0];
  }
  return value;
}
